<template>
  <div :class="['ms-form ms-form--narrow', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomInputNumber
          label="Сумма договора"
          :value="this.formData.agreement_sum"
          @change_input="(value) => onChange('agreement_sum', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInputNumber from "@/components/form/CustomInputNumber";

export default {
  name: "create-additional-agreement",
  components: {CustomInputNumber, CustomModalFooter, },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        agreement_sum: this.data?.body?.agreement_sum || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit({...this.formData, agreement_sum: Math.round(this.formData.agreement_sum)})
      this.loading = false
    },
  },
}
</script>
